import { render } from "./NewMail.vue?vue&type=template&id=7f925d98&scoped=true"
import script from "./NewMail.vue?vue&type=script&lang=js"
export * from "./NewMail.vue?vue&type=script&lang=js"

import "./NewMail.vue?vue&type=style&index=0&id=7f925d98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f925d98"]])

export default __exports__